import useTicketMutations from "../../data/Ticket/useTicketMutations";
import { TicketFeatureDecision } from "../../models/Tickets/Ticket";
import TicketPillMenu from "./TicketPillMenu";
import {
  featureDecisionClassMap,
  ticketFeatureDecisionLabels,
  ticketFeatureDecisionOptions,
} from "./ticketMeta";

interface TicketFeatureDecisionMenuProps {
  ticketId: string;
  decision?: TicketFeatureDecision;
  align?: "left" | "right";
  className?: string;
}

/**
 * Editable counterpart to TicketFeatureDecisionPill. Unlike the pill it shows
 * Undecided too, since that's the state you'd come here to change. Only render
 * it for feature tickets - the API ignores the decision on bugs.
 */
export default function TicketFeatureDecisionMenu({
  ticketId,
  decision,
  align,
  className,
}: TicketFeatureDecisionMenuProps) {
  const { update } = useTicketMutations();

  return (
    <TicketPillMenu
      value={decision ?? TicketFeatureDecision.Undecided}
      options={ticketFeatureDecisionOptions}
      labels={ticketFeatureDecisionLabels}
      classMap={featureDecisionClassMap}
      onSelect={(next) => update.mutate({ id: ticketId, featureDecision: next })}
      isPending={update.isPending}
      title="Change feature decision (internal - not visible to the customer)"
      heading="Feature decision"
      align={align}
      className={className}
    />
  );
}
